import React, {useEffect,useState,useMemo} from "react";

import "./invoice-details.scss";

import { CASE_DETAILS_CONSTANTS } from "../../../constants/constants";

import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";
import { McModal } from "@maersk-global/mds-react-wrapper/mc-modal";
import { McOption, McSelect, McTooltip } from "@maersk-global/mds-react-wrapper";
import { McStepIndicator } from "@maersk-global/mds-react-wrapper/components-core/mc-step-indicator";
import { CORE_URL, API_URL, GET_FILE_API } from "../../../services/api-config";
import { renderPdf, renderDocx, renderImage } from "../pop-details/pop-types";
import { McLoadingIndicator } from "@maersk-global/mds-react-wrapper/mc-loading-indicator";
import { useStore } from "../../../store/store.context";
import { formatDateAndTime } from "../../../utils/helper";
import axios from "axios";
import { McNotification } from "@maersk-global/mds-react-wrapper";
import EmailPreviewModal from "../case-details-header/EmailPreviewModal";
import EmailHistoryModal from "../case-details-header/EmailHistoryModal";
import { McTag } from "@maersk-global/mds-react-wrapper/components-core/mc-tag";
import NextStepModal from "../../shared/NextStepModal";
import { CASE_STATUS_ID_MAP, CASE_REJECT_REASON_OPTIONS } from "../../../constants/case-status";
import {
  EMPTY_POP,
  validateBlNumber,
  getFilledPopFieldsCount,
  isPaymentFormChanged as isPaymentFormChangedUtil,
  isPopDocChanged as isPopDocChangedUtil,
  isAnyPaymentFieldFilled as isAnyPaymentFieldFilledUtil,
  resolveStatusKey,
  fetchPaymentProofData as fetchPaymentProofDataUtil,
  buildPaymentProofPayload,
  fetchFreshPopId,
} from "../../../utils/payment-proof-helpers";


const InvoiceDetails = ({ caseDetailsInfo, onCaseRefresh }) => {
  const { 
    bldetails, 
    casestatus, 
    createddate, 
    modifieddate, 
    casenumber, 
    casestatusreason, 
    country,
    paymentreference,
    paymentamount,
    beneficiaryname,
    beneficiaryaccount,
    payer_name,
    popcurrency
  } = caseDetailsInfo;
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  // For multi-select reasons
  const [rejectReasons, setRejectReasons] = useState([]); // array of strings
  const [customRejectText, setCustomRejectText] = useState("");
  const [processing, setProcessing] = useState(false);
  const [processError, setProcessError] = useState("");
  
  const [currentStatus, setCurrentStatus] = useState(casestatus);
  const [statusReason, setStatusReason] = useState(null);
  const [comments,setComments]= useState('')
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const [revalidating, setRevalidating] = useState(false);
  const [revalidateConfirmStep, setRevalidateConfirmStep] = useState(null); // null | 'confirm' | 'comments'
  const [pendingStatusKey, setPendingStatusKey] = useState(null);
  const [revalidateStatusMsg, setRevalidateStatusMsg] = useState(null);
  const [revalidatedStatus, setRevalidatedStatus] = useState(null);
  
  // Payment details state (for Approve action) — BL/Invoice shared; POP details per-document
  const [sharedBlNumber, setSharedBlNumber] = useState("");
  const [sharedInvoiceNumber, setSharedInvoiceNumber] = useState("");
  const [sharedBlNumberError, setSharedBlNumberError] = useState("");
  const [originalSharedBl, setOriginalSharedBl] = useState("");
  const [originalSharedInvoice, setOriginalSharedInvoice] = useState("");
  const emptyPop = EMPTY_POP;
  const [popDocuments, setPopDocuments] = useState([{ ...emptyPop }]);
  const [originalPopDocuments, setOriginalPopDocuments] = useState([{ ...emptyPop }]);
  const [submittingPayment, setSubmittingPayment] = useState(false);
  const [loadingPaymentProof, setLoadingPaymentProof] = useState(false);
  const [paymentProofSaved, setPaymentProofSaved] = useState(false);
  
  const { store, updateStore } = useStore();
  

  //Email Modal and Notification state(Srishti)
  const [notification, setNotification] = useState(null);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  
  //Email History state
  const [isEmailHistoryModalOpen, setIsEmailHistoryModalOpen] = useState(false);
  
  // Close AFR in GCSS state
  const [isCloseAfrModalOpen, setIsCloseAfrModalOpen] = useState(false);
  const [closingAfr, setClosingAfr] = useState(false);
  const [afrExecutionLogs, setAfrExecutionLogs] = useState([]);
  const [afrCloseResult, setAfrCloseResult] = useState(null);
  const [afrStatusCheck, setAfrStatusCheck] = useState(null); // null | 'loading' | { status, data }
  /** BL numbers selected for GCSS close (checkboxes); default all eligible when modal reaches confirm step */
  const [selectedBlNumbersForClose, setSelectedBlNumbersForClose] = useState([]);

  const ACTION_COMPLIANT_GCSS = 'COMPLIANT-GCSS';
  const DEFAULT_COMPLIANT_GCSS_COMMENT =
    'Marked compliant and GCSS AFR task closed';

  /** Individual BL strings for close modal (comma-separated values in one row become multiple checkboxes) */
  const closeAfrEligibleBls = useMemo(() => {
    if (!Array.isArray(bldetails)) return [];
    const parts = [];
    for (const b of bldetails) {
      const s = (b?.blnumber || "").trim();
      if (!s) continue;
      s.split(",").forEach((piece) => {
        const t = piece.trim();
        if (t) parts.push(t);
      });
    }
    return [...new Set(parts)];
  }, [bldetails]);

  /** BLs marked CLOSED in afr_task_status (from latest GET when modal opens); refreshed each time user opens Close AFR */
  const afrClosedBlNumbersFromStatus = useMemo(() => {
    const perBl = afrStatusCheck?.data?.per_bl;
    if (!Array.isArray(perBl)) return new Set();
    const closed = new Set();
    perBl.forEach((row) => {
      const bl = String(row?.bl_number ?? "").trim();
      if (!bl) return;
      if (String(row?.task_status ?? "").toUpperCase() === "CLOSED") closed.add(bl);
    });
    return closed;
  }, [afrStatusCheck]);

  /** Invoice BLs that are not already closed in GCSS / afr_task_status — only these may be selected */
  const closeAfrSelectableBls = useMemo(
    () => closeAfrEligibleBls.filter((bl) => !afrClosedBlNumbersFromStatus.has(bl)),
    [closeAfrEligibleBls, afrClosedBlNumbersFromStatus]
  );

  /** Show Close AFR when status allows GCSS close and at least one BL is not closed yet. */
  const showCloseAfrInGcssButton = useMemo(() => {
    if (!casenumber) return false;
    const effectiveStatus = (store?.detailsStatus || '').toLowerCase().includes('reopened')
      ? store.detailsStatus
      : currentStatus;
    const ns = (effectiveStatus || '').toUpperCase();
    if (ns !== 'APPROVED' && ns !== 'COMPLIANT') return false;
    if (afrStatusCheck === 'loading') return false;
    if (closeAfrEligibleBls.length === 0) return false;
    if (afrStatusCheck?.status === 'found') return false;
    return closeAfrSelectableBls.length > 0;
  }, [
    casenumber,
    currentStatus,
    store?.detailsStatus,
    afrStatusCheck,
    closeAfrEligibleBls,
    closeAfrSelectableBls,
  ]);

  // Sync local status when prop changes (e.g., parent refresh)
  useEffect(() => {
    setCurrentStatus(casestatus);
  }, [casestatus]);

  const triggerCaseRefresh = () => {
    if (typeof onCaseRefresh !== 'function') return;
    onCaseRefresh();
    setTimeout(() => { try { onCaseRefresh(); } catch (_) {} }, 1500);
  };

  useEffect(() => {
    if (!modalOpen && paymentProofSaved) {
      setPaymentProofSaved(false);
      triggerCaseRefresh();
    }
  }, [modalOpen, paymentProofSaved]);
 
  useEffect(() => {
    const action = (selectedAction || '').toLowerCase();
    setUpdatingStatus(false); // Always reset on action change to unblock Submit
    if (action === ACTION_COMPLIANT_GCSS.toLowerCase()) {
      fetchAfrTaskStatusForClose();
    }
    if (action !== 'reject' && action !== 'non-compliant') {
      setRejectReasons([]);
      setCustomRejectText("");
    }
    // Set default comments based on action
    if (action === 'non-afr') {
      setComments('Non-AFR');
    } else if (action === ACTION_COMPLIANT_GCSS.toLowerCase()) {
      setComments(DEFAULT_COMPLIANT_GCSS_COMMENT);
    } else {
      setComments('');
    }
    // Clear payment fields if action is not approve
    if (action !== 'approve') {
      setSharedBlNumber(""); setSharedInvoiceNumber(""); setSharedBlNumberError("");
      setOriginalSharedBl(""); setOriginalSharedInvoice("");
      setPopDocuments([{ ...emptyPop }]);
      setOriginalPopDocuments([{ ...emptyPop }]);
    } else if (action === 'approve') {
      setOriginalPopDocuments(popDocuments.map(p => ({ ...p })));
      setRevalidateConfirmStep(null);
      setPendingStatusKey(null);
      setRevalidateStatusMsg(null);
    }
  }, [selectedAction]);

  // Fetch existing payment proof data when "Approve" action is selected
  useEffect(() => {
    const action = (selectedAction || '').toLowerCase();
    if (action === 'approve' && casenumber) {
      fetchPaymentProofData();
    }
  }, [selectedAction, casenumber]);

  const fetchPaymentProofData = async () => {
    setLoadingPaymentProof(true);
    try {
      const paymentProofData = await fetchPaymentProofDataUtil(casenumber, store.authToken);

      // Helper returns null when no payment proof exists (e.g., 404).
      if (!paymentProofData) {
        setSharedBlNumber(""); setSharedInvoiceNumber(""); setSharedBlNumberError("");
        setOriginalSharedBl(""); setOriginalSharedInvoice("");
        setPopDocuments([{ ...emptyPop }]);
        setOriginalPopDocuments([{ ...emptyPop }]);
        return;
      }

      const { sharedBl, sharedInvoice, popDocuments: docs } = paymentProofData;

      setSharedBlNumber(sharedBl);
      setSharedInvoiceNumber(sharedInvoice);
      setOriginalSharedBl(sharedBl);
      setOriginalSharedInvoice(sharedInvoice);
      setSharedBlNumberError("");

      setPopDocuments(docs);
      setOriginalPopDocuments(docs.map(d => ({ ...d })));
    } catch (err) {
      if (err.response?.status !== 404) {
        console.error('Error fetching payment proof data:', err.message);
      }
      setSharedBlNumber(""); setSharedInvoiceNumber(""); setSharedBlNumberError("");
      setOriginalSharedBl(""); setOriginalSharedInvoice("");
      setPopDocuments([{ ...emptyPop }]);
      setOriginalPopDocuments([{ ...emptyPop }]);
    } finally {
      setLoadingPaymentProof(false);
    }
  };
 
  useEffect(() => {
    // Clear custom text when Other is deselected
    if (!rejectReasons.includes('Other')) {
      setCustomRejectText("");
    }
  }, [rejectReasons]);

  // Reset transient local state when switching to a different case
  useEffect(() => {
    if (!casenumber) return;
  // Clear any previous global caseStatusReason to avoid showing stale reason from another case
  updateStore({ caseStatusReason: '' });
    setSelectedAction('');
    setRejectReasons([]);
    setCustomRejectText('');
    setComments('');
    setSharedBlNumber(""); setSharedInvoiceNumber(""); setSharedBlNumberError("");
    setOriginalSharedBl(""); setOriginalSharedInvoice("");
    setPopDocuments([{ ...emptyPop }]);
    setOriginalPopDocuments([{ ...emptyPop }]);
    setProcessing(false);
    setProcessError('');
    
    setUpdatingStatus(false);
    setRevalidateConfirmStep(null);
    setPendingStatusKey(null);
    setRevalidateStatusMsg(null);
    setRevalidatedStatus(null);
    setStatusReason(casestatusreason || '');
  }, [casenumber]);

  // If action was selected in the case-table pre-navigation modal, open the same
  // next-step modal here and continue with the full Invoice Details workflow.
  useEffect(() => {
    if (!casenumber) return;
    const preAction = String(store?.preselectedNextAction || '').trim();
    if (!preAction) return;

    const meta = store?.preselectedNextActionMeta || {};
    const normalized = preAction.toLowerCase();

    setSelectedAction(preAction);
    setModalOpen(true);

    if (normalized === 'reject' || normalized === 'non-compliant') {
      const reasons = Array.isArray(meta.reasons) ? meta.reasons : [];
      setRejectReasons(reasons);
      setCustomRejectText(meta.customReason || '');
    }

    if (typeof meta.comments === 'string') {
      setComments(meta.comments);
    }

    updateStore({ preselectedNextAction: '', preselectedNextActionMeta: null });
  }, [casenumber, store?.preselectedNextAction, store?.preselectedNextActionMeta, updateStore]);

  // Sync status reason from props unless an in-flight processing/update
  useEffect(() => {
    if (!processing && !updatingStatus) {
      setStatusReason(casestatusreason || '');
    }
  }, [casestatusreason, processing, updatingStatus]);
 
  const toggleReason = (reason) => {
    if(reason == 'Other'){
    rejectReasons.includes('Other') ? setRejectReasons([]) : setRejectReasons(['Other'])

    }
    else{
    setRejectReasons(prev => prev.includes(reason) ? prev.filter(r => r !== reason) : [...prev, reason]);
    }
  };

  // Helper: Update a field in a specific POP document
  const updatePopField = (index, field, value) => {
    setPopDocuments(prev => prev.map((p, i) => i === index ? { ...p, [field]: value } : p));
  };

  // Helper: Toggle expanded state of a POP document
  const togglePopExpanded = (index) => {
    setPopDocuments(prev => prev.map((p, i) => i === index ? { ...p, expanded: !p.expanded } : p));
  };

  // Helper: Count filled payment fields for a POP document (8 POP fields)
  // Uses shared utility: getFilledPopFieldsCount from payment-proof-helpers

  // Helper: Check if a field is filled (for highlighting)
  const isFieldFilled = (value) => {
    return value && String(value).trim().length > 0;
  };

  // Wrappers around shared utilities that bind current component state
  const isPaymentFormChanged = () =>
    isPaymentFormChangedUtil(sharedBlNumber, originalSharedBl, sharedInvoiceNumber, originalSharedInvoice, popDocuments, originalPopDocuments);

  const isPopDocChanged = (index) =>
    isPopDocChangedUtil(index, popDocuments, originalPopDocuments);

  const isAnyPaymentFieldFilled = () =>
    isAnyPaymentFieldFilledUtil(sharedBlNumber, sharedInvoiceNumber, popDocuments);

  // Helper: Get field background style based on fill state
  const getFieldStyle = (value) => {
    return {
      width: '-webkit-fill-available',
      padding: '8px',
      border: '1px solid #d0d0d0',
      borderRadius: '4px',
      fontSize: '13px',
      fontFamily: 'inherit',
      backgroundColor: isFieldFilled(value) ? '#f0f8ff' : 'transparent',
      transition: 'background-color 0.2s ease'
    };
  };

  // validateBlNumber is imported from shared utils
 
  const reasonOptions = CASE_REJECT_REASON_OPTIONS;

  // Map status labels to their numeric IDs (dynamic payload usage)
  const STATUS_ID_MAP = CASE_STATUS_ID_MAP;

  // resolveStatusKey is imported from shared utils

  // const openStepLabel = createddate ? `${formatDateAndTime(createddate)}` : 'Open';
  // const modifiedStepLabel = modifieddate ? `${formatDateAndTime(modifieddate)}` : '';
  const openStepLabel = createddate ? `${formatDateAndTime(createddate)}` : 'Open';
  const modifiedStepLabel = modifieddate ? `${formatDateAndTime(modifieddate)}` : '';
  // Build label that contains case status on first line and modified date on second line
  const casestatusWithModified = modifiedStepLabel
    ? `${currentStatus} - ${modifiedStepLabel}`
    : currentStatus;
  const effectiveStatus = ((store?.detailsStatus || '').toLowerCase().includes('reopened'))
    ? store.detailsStatus
    : currentStatus;
  const normalizedStatus = (effectiveStatus || '').toUpperCase();


  // Retrieve user info from sessionStorage (requested change)
  const updatedUserInfo = typeof window !== 'undefined' ? sessionStorage.getItem('userInfo') : null;
  let parsedUserInfo = {};
  if (updatedUserInfo) {
    try { parsedUserInfo = JSON.parse(updatedUserInfo) || {}; } catch (e) { parsedUserInfo = {}; }
  }

  //Email Modal Handlers (Srishti)
const missingFields = useMemo(() => {
  // If case status is APPROVED or REJECTED, return empty array
  if (casestatus === 'APPROVED' || casestatus === 'REJECTED') {
    return [];
  }
  
  let fields = [];
 
  // Ensure missingFields is always an array of strings
  if (Array.isArray(casestatusreason)) {
    fields = casestatusreason.map(f => String(f).trim());
  } else if (typeof casestatusreason === "string" && casestatusreason.trim()) {
    fields = [casestatusreason.trim()];
  }
 
  return fields;
}, [casestatusreason, casestatus]);
 
// const { store } = useStore(); // Access authToken from store (already obtained earlier)
 
const handleSendEmailMissingDocuments = () => {
  setIsEmailModalOpen(true);
};
 
const handleEmailModalClose = () => {
  setIsEmailModalOpen(false);
};
 
const handleEmailSent = () => {
  setNotification({
    type: "success",
    message: "Email sent successfully!",
  });
  setTimeout(() => setNotification(null), 3000);
};

// Email History Modal Handlers
const handleOpenEmailHistory = () => {
  setIsEmailHistoryModalOpen(true);
};

const handleCloseEmailHistory = () => {
  setIsEmailHistoryModalOpen(false);
};

  /** Request/response details — console only (not shown in the modal). */
  const logCloseAfrDebug = (message) => {
    const line = `[${new Date().toISOString()}] ${message}`;
    console.info("[Close AFR in GCSS]", line);
  };

  const toggleCloseBlSelection = (bl) => {
    if (!closeAfrSelectableBls.includes(bl)) return;
    setSelectedBlNumbersForClose((prev) =>
      prev.includes(bl) ? prev.filter((x) => x !== bl) : [...prev, bl]
    );
  };

  useEffect(() => {
    if (!isCloseAfrModalOpen) return;
    if (afrStatusCheck === "loading" || afrStatusCheck?.status === "found") return;
    if (afrStatusCheck?.status === "not_found" || afrStatusCheck?.status === "open") {
      if (closeAfrSelectableBls.length > 0) {
        setSelectedBlNumbersForClose([...closeAfrSelectableBls]);
      } else {
        setSelectedBlNumbersForClose([]);
      }
    }
  }, [isCloseAfrModalOpen, afrStatusCheck, closeAfrSelectableBls]);

  useEffect(() => {
    if (!modalOpen) return;
    if ((selectedAction || '').toUpperCase() !== ACTION_COMPLIANT_GCSS) return;
    if (afrStatusCheck === 'loading' || afrStatusCheck?.status === 'found') return;
    if (afrStatusCheck?.status === 'not_found' || afrStatusCheck?.status === 'open') {
      if (closeAfrSelectableBls.length > 0) {
        setSelectedBlNumbersForClose([...closeAfrSelectableBls]);
      } else {
        setSelectedBlNumbersForClose([]);
      }
    }
  }, [modalOpen, selectedAction, afrStatusCheck, closeAfrSelectableBls]);

const fetchAfrTaskStatusForClose = async () => {
  setAfrStatusCheck('loading');
  setSelectedBlNumbersForClose([]);
  try {
    const statusRes = await axios.get(
      `${API_URL}/afr_task_status/${casenumber}`,
      { headers: { Authorization: `Bearer ${store.authToken}` } }
    );
    const body = statusRes.data?.body;
    const isSuccess = statusRes.data?.statusCode === 200 && body;
    if (!isSuccess) {
      setAfrStatusCheck({ status: 'not_found' });
      return;
    }
    const aggregateClosed = (body.task_status || '').toUpperCase() === 'CLOSED';
    if (aggregateClosed) {
      setAfrStatusCheck({ status: 'found', data: body });
    } else {
      setAfrStatusCheck({ status: 'open', data: body });
    }
    logCloseAfrDebug(
      `afr_task_status: aggregate=${body.task_status}, per_bl rows=${Array.isArray(body.per_bl) ? body.per_bl.length : 0}`
    );
  } catch (err) {
    if (err.response?.status === 404) {
      logCloseAfrDebug('afr_task_status: 404 — no rows yet; all invoice BLs treated as not closed.');
    } else {
      logCloseAfrDebug(`afr_task_status GET failed: ${err.message || err}`);
    }
    setAfrStatusCheck({ status: 'not_found' });
  }
};

  useEffect(() => {
    if (!casenumber) return;
    fetchAfrTaskStatusForClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refresh when case is opened
  }, [casenumber]);

const validateCloseBlSelection = () => {
  const invalidPick = selectedBlNumbersForClose.some((bl) => !closeAfrSelectableBls.includes(bl));
  if (invalidPick) {
    logCloseAfrDebug('Validation failed: selection includes BL already closed in GCSS.');
    setNotification({
      type: 'error',
      message: 'Remove BLs that are already closed. Refresh the dialog if the list looks wrong.',
    });
    setTimeout(() => setNotification(null), 5000);
    return false;
  }
  if (closeAfrSelectableBls.length > 0 && selectedBlNumbersForClose.length === 0) {
    logCloseAfrDebug('Validation failed: select at least one BL number (or use Select all).');
    setNotification({
      type: 'error',
      message: 'Select at least one BL number to close in GCSS.',
    });
    setTimeout(() => setNotification(null), 5000);
    return false;
  }
  return true;
};

const buildCloseAfrPayload = () => {
  const userEmail = parsedUserInfo?.email || parsedUserInfo?.userEmail || '';
  const payload = {
    casenumbers: [casenumber],
    modifiedby: userEmail,
    modifieddatetime: new Date().toISOString(),
    request_source: 'UI',
  };
  if (selectedBlNumbersForClose.length > 0) {
    payload.blnumbers = selectedBlNumbersForClose.filter((bl) => closeAfrSelectableBls.includes(bl));
  }
  return payload;
};

/** Classify close_afr_task case result for UI messaging (logging is done server-side in afr_task_status). */
const summarizeCloseAfrCaseResult = (caseResult) => {
  if (!caseResult) {
    return { level: 'error', message: 'No case result returned from close_afr_task.' };
  }
  const blResults = caseResult.bl_results || {};
  if (blResults.error) {
    return { level: 'error', message: blResults.error };
  }
  const entries = Object.entries(blResults).filter(([key]) => key !== 'error');
  if (entries.length === 0) {
    return { level: 'error', message: 'Close AFR returned no BL outcomes.' };
  }
  const closed = entries.filter(
    ([, value]) => value && typeof value === 'object' && value.status === 'closed'
  );
  const failed = entries.filter(
    ([, value]) =>
      value &&
      typeof value === 'object' &&
      (value.status === 'failed' || value.status === 'error')
  );
  const skipped = entries.filter(
    ([, value]) =>
      typeof value === 'string' ||
      (value && typeof value === 'object' && value.status === 'skipped')
  );
  if (closed.length === entries.length) {
    return {
      level: 'success',
      message: `AFR closed in GCSS for ${closed.length} BL(s). Logged to afr_task_status.`,
    };
  }
  if (closed.length > 0) {
    return {
      level: 'warning',
      message: `Partial close: ${closed.length} closed, ${failed.length + skipped.length} not closed. See execution log.`,
    };
  }
  const firstSkipped = skipped[0]?.[1];
  const firstFailed = failed[0]?.[1];
  if (typeof firstSkipped === 'string') {
    return { level: 'error', message: firstSkipped };
  }
  if (firstFailed?.error_message) {
    return { level: 'error', message: firstFailed.error_message };
  }
  if (firstFailed?.status) {
    return { level: 'error', message: `GCSS close failed (${firstFailed.status}).` };
  }
  return { level: 'error', message: 'AFR close did not complete for the selected BL(s).' };
};

const hasSuccessfulAfrClose = (caseResult) => {
  const results = caseResult?.bl_results;
  if (!results || results.error) return false;
  return Object.values(results).some(
    (r) =>
      typeof r === 'object' &&
      r !== null &&
      (r.status === 'closed' || r.status === 'would_close')
  );
};

const executeCloseAfrRequest = async (endpointPath, { successLabel = 'AFR task closure initiated' } = {}) => {
  const payload = buildCloseAfrPayload();
  logCloseAfrDebug(`Request: PUT ${API_URL}/${endpointPath}`);
  logCloseAfrDebug(`Payload: ${JSON.stringify(payload)}`);

  const response = await axios.put(`${API_URL}/${endpointPath}`, payload, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${store.authToken}`,
    },
  });

  const bodyPreview = JSON.stringify(response.data);
  logCloseAfrDebug(`Response: HTTP ${response.status} ${response.statusText || 'OK'}`);
  logCloseAfrDebug(
    bodyPreview.length > 12000
      ? `Body (truncated): ${bodyPreview.slice(0, 12000)}…`
      : `Body: ${bodyPreview}`
  );

  const caseResult = response.data?.cases?.[casenumber];
  if (caseResult) {
    setAfrExecutionLogs(caseResult.execution_logs || []);
    setAfrCloseResult(caseResult);
    logCloseAfrDebug(
      `bl_results persisted server-side to afr_task_status.gcss_api_logs (modified_by=UI : ${payload.modifiedby || 'unknown'})`
    );
  }

  // Refresh from DB after every attempt (success, validation error, or partial close).
  await fetchAfrTaskStatusForClose();

  const summary = summarizeCloseAfrCaseResult(caseResult);
  const blSuffix = payload.blnumbers?.length ? ` (${payload.blnumbers.length} BL(s))` : '';
  if (summary.level === 'success') {
    setNotification({
      type: 'success',
      message: `${successLabel} for case ${casenumber}${blSuffix}. ${summary.message}`,
    });
  } else if (summary.level === 'warning') {
    setNotification({
      type: 'error',
      message: `${successLabel} for case ${casenumber}${blSuffix}. ${summary.message}`,
    });
  } else {
    setNotification({
      type: 'error',
      message: summary.message,
    });
  }
  setTimeout(() => setNotification(null), 8000);

  if (summary.level === 'error') {
    const err = new Error(summary.message);
    err.caseResult = caseResult;
    throw err;
  }

  return caseResult;
};

// Close AFR Task in GCSS Handler (Advaita)
const handleCloseAfrInGcss = async () => {
  setIsCloseAfrModalOpen(true);
  setClosingAfr(false);
  setAfrExecutionLogs([]);
  setAfrCloseResult(null);
  setSelectedBlNumbersForClose([]);
  await fetchAfrTaskStatusForClose();
};

const handleConfirmCloseAfr = async () => {
  if (!validateCloseBlSelection()) return;

  setClosingAfr(true);
  logCloseAfrDebug(`"Yes, Close AFR" clicked for case ${casenumber}.`);

  try {
    await executeCloseAfrRequest('close_afr_task');
  } catch (error) {
    const status = error.response?.status;
    const detail = error.response?.data?.detail;
    const dataStr = error.response?.data ? JSON.stringify(error.response.data) : '';
    const caseResult = error.caseResult;

    logCloseAfrDebug(`Response: FAILED — ${error.message || 'Unknown error'}`);
    if (status != null) logCloseAfrDebug(`HTTP status: ${status}`);
    if (detail) logCloseAfrDebug(`Detail: ${typeof detail === 'string' ? detail : JSON.stringify(detail)}`);
    if (dataStr) {
      logCloseAfrDebug(
        dataStr.length > 8000 ? `Error body (truncated): ${dataStr.slice(0, 8000)}…` : `Error body: ${dataStr}`
      );
    }

    if (caseResult?.execution_logs?.length) {
      setAfrExecutionLogs(caseResult.execution_logs);
      setAfrCloseResult(caseResult);
    } else {
      setAfrExecutionLogs((prev) => [...prev, error.message || 'Close AFR failed']);
    }

    if (!caseResult) {
      await fetchAfrTaskStatusForClose().catch(() => {});
      const errorMsg = detail
        ? `Failed: ${typeof detail === 'string' ? detail : JSON.stringify(detail)}`
        : `Error: ${error.message}`;
      setNotification({ type: 'error', message: errorMsg });
      setTimeout(() => setNotification(null), 8000);
    }
  } finally {
    setClosingAfr(false);
  }
};

const handleCompliantGcssClosure = async () => {
  if (afrStatusCheck === 'loading') {
    setNotification({ type: 'error', message: 'Please wait for BL status to finish loading.' });
    setTimeout(() => setNotification(null), 3000);
    return;
  }
  if (afrStatusCheck?.status === 'found') {
    setNotification({
      type: 'error',
      message: 'AFR task is already closed in GCSS for this case.',
    });
    setTimeout(() => setNotification(null), 3000);
    return;
  }
  if (!validateCloseBlSelection()) return;

  const comment = comments || '';
  setUpdatingStatus(true);

  try {
    await submitCaseStatusUpdate('COMPLIANT', comment, { closeModal: false });
    setCurrentStatus('COMPLIANT');
    setModalOpen(false);
    setSelectedAction('');
    setComments('');

    setIsCloseAfrModalOpen(true);
    setClosingAfr(true);
    setAfrCloseResult(null);
    setAfrExecutionLogs([]);

    logCloseAfrDebug(`Compliant & GCSS Closure: status set to COMPLIANT for case ${casenumber}.`);

    await executeCloseAfrRequest('close_afr_task', {
      successLabel: 'Compliant status saved; AFR task closed in GCSS',
    });
  } catch (error) {
    const detail = error.response?.data?.detail;
    const caseResult = error.caseResult;

    if (caseResult?.execution_logs?.length) {
      setAfrExecutionLogs(caseResult.execution_logs);
      setAfrCloseResult(caseResult);
    }

    if (!caseResult) {
      await fetchAfrTaskStatusForClose().catch(() => {});
      const errorMsg = detail
        ? `Failed: ${typeof detail === 'string' ? detail : JSON.stringify(detail)}`
        : error.message || 'Compliant & GCSS Closure failed.';
      setNotification({ type: 'error', message: errorMsg });
      setTimeout(() => setNotification(null), 8000);
    }

    if (!isCloseAfrModalOpen) {
      setModalOpen(true);
      setSelectedAction(ACTION_COMPLIANT_GCSS);
    }
  } finally {
    setUpdatingStatus(false);
    setClosingAfr(false);
  }
};

const handleCloseAfrModal = () => {
  setIsCloseAfrModalOpen(false);
  setAfrExecutionLogs([]);
  setAfrCloseResult(null);
  setAfrStatusCheck(null);
  setSelectedBlNumbersForClose([]);
};

const handleModalClose = () => {
    // If revalidation updated the case status, reflect it in the UI before closing
    if (revalidatedStatus && revalidatedStatus !== currentStatus) {
      setCurrentStatus(revalidatedStatus);
      updateStore({
        detailsStatus: revalidatedStatus,
        promptQuery: `Show me the case details for ${casenumber}`,
      });
      updatePreviousViewStatus(casenumber);
    }
    setRevalidatedStatus(null);
    setModalOpen(false);
    setSelectedAction('');
    setRejectReasons([]);
    setCustomRejectText('');
    setComments('');
    setSharedBlNumber(""); setSharedInvoiceNumber(""); setSharedBlNumberError("");
    setOriginalSharedBl(""); setOriginalSharedInvoice("");
    setPopDocuments([{ ...emptyPop }]);
    setOriginalPopDocuments([{ ...emptyPop }]);
    setUpdatingStatus(false);
    setRevalidateConfirmStep(null);
    setPendingStatusKey(null);
    setRevalidateStatusMsg(null);
  };

  const handleCaseStatusSubmit = () => {
    if (updatingStatus) return; // prevent duplicate submits

    const lowerAction = (selectedAction || '').toLowerCase();

    if (lowerAction === 'compliant-gcss' || selectedAction === ACTION_COMPLIANT_GCSS) {
      handleCompliantGcssClosure();
      return;
    }

    // If in the comments confirmation step for approve — submit status update directly
    if (lowerAction === 'approve' && revalidateConfirmStep === 'comments') {
      if (!pendingStatusKey || !STATUS_ID_MAP[pendingStatusKey]) {
        setNotification({ type: 'error', message: 'Invalid status.' });
        setTimeout(() => setNotification(null), 3000);
        return;
      }
      setUpdatingStatus(true);
      submitCaseStatusUpdate(pendingStatusKey, comments || 'AFR closed')
        .catch(err => {
          setNotification({ type: 'error', message: err.response?.data?.detail || 'Failed to update status.' });
          setTimeout(() => setNotification(null), 3000);
        })
        .finally(() => setUpdatingStatus(false));
      return;
    }

    const comment = (lowerAction === 'non-compliant' || lowerAction === 'reject')
      ? (rejectReasons.includes('Other') ? customRejectText : rejectReasons.join(', '))
      : (lowerAction === 'non-afr' ? (comments || 'Non-AFR') : comments);

    const nextStatusKey = resolveStatusKey(selectedAction);
    if (!nextStatusKey || !STATUS_ID_MAP[nextStatusKey]) {
      setNotification({ type: 'error', message: 'Please select a valid action before submitting.' });
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    // For approve action: block if BL number fails validation
    if (lowerAction === 'approve' && sharedBlNumberError) {
      setNotification({ type: 'error', message: sharedBlNumberError });
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    // For approve action: require at least one payment field to be filled
    if (lowerAction === 'approve' && !isAnyPaymentFieldFilled()) {
      setNotification({ type: 'error', message: 'Please fill in at least one payment proof field before approving.' });
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    // For approve action: always go through submitPaymentAndApprove — it handles
    // per-POP change detection internally and calls submitCaseStatusUpdate afterward.
    if (lowerAction === 'approve') {
      submitPaymentAndApprove(nextStatusKey, comment);
    } else {
      // For non-approve actions, update status directly
      setUpdatingStatus(true);
      submitCaseStatusUpdate(nextStatusKey, comment)
        .catch(err => {
          setNotification({ type: 'error', message: err.response?.data?.detail || 'Failed to update status.' });
          setTimeout(() => setNotification(null), 3000);
        })
        .finally(() => setUpdatingStatus(false));
    }
  };

  // Submit payment details for all POP documents and then approve
  const submitPaymentAndApprove = async (nextStatusKey, comment) => {
    setUpdatingStatus(true);

    try {
      // Only update payment proof records when something has actually changed
      if (isPaymentFormChanged()) {
      const sharedFieldsChanged = (sharedBlNumber !== originalSharedBl) || (sharedInvoiceNumber !== originalSharedInvoice);
      for (let i = 0; i < popDocuments.length; i++) {
        const pop = popDocuments[i];
        const hasAnyField = !!(sharedBlNumber || sharedInvoiceNumber || pop.paymentProofRef || pop.paymentProofDate ||
          pop.amountInPaymentProof || pop.currencyInPaymentProof || pop.beneficiaryName ||
          pop.bankAccountNumber || pop.payerName || pop.taxIdNumber);

        // Skip only if POP has no existing popid AND no field data at all
        if (!pop.popid && !hasAnyField) continue;

        // Skip this POP if its own fields haven't changed AND shared fields haven't changed
        if (!sharedFieldsChanged && !isPopDocChanged(i)) continue;

        // If popid is null, try to fetch it fresh
        let currentPopid = pop.popid;
        if (!currentPopid && casenumber) {
          currentPopid = await fetchFreshPopId(casenumber, i, store.authToken);
        }

        const paymentPayload = buildPaymentProofPayload({
          caseNumber: casenumber,
          pop,
          popid: currentPopid,
          sharedBl: sharedBlNumber,
          sharedInvoice: sharedInvoiceNumber,
          modifiedBy: parsedUserInfo?.email || parsedUserInfo?.userEmail,
        });

        console.debug(`Updating payment proof ${i + 1} for case ${casenumber} with popid: ${currentPopid}`, paymentPayload);
        const updateResponse = await axios.put(
          `${API_URL}/update_proofofpayment`,
          paymentPayload,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${store.authToken}`,
            },
          }
        );
        console.debug(`Successfully updated payment proof ${i + 1} for case ${casenumber}`, updateResponse.data);
        
        // Sync popid from response if available
        if (updateResponse.data?.popid) {
          updatePopField(i, 'popid', updateResponse.data.popid);
        }
      }
      setPaymentProofSaved(true);
      } // end isPaymentFormChanged()

      // Revalidate dynamic data if BL Number or Invoice Number was changed
      const blChanged = (sharedBlNumber || "").trim() !== (originalSharedBl || "").trim();
      const invChanged = (sharedInvoiceNumber || "").trim() !== (originalSharedInvoice || "").trim();
      let revalidatedCaseStatus = null;
      if (blChanged || invChanged) {
        const revalidatePayload = {
          case_number: casenumber,
          ...(blChanged && { bill_of_lading: (sharedBlNumber || "").trim() }),
          ...(invChanged && { inv_number: (sharedInvoiceNumber || "").trim() }),
          refresh_scope: ["gcss"],
          modifiedby: parsedUserInfo?.email || parsedUserInfo?.userEmail || "",
          modifieddate: "",
        };
        setRevalidating(true);
        try {
          const revalRes = await axios.post(
            `${CORE_URL}/revalidate-dynamic-data`,
            revalidatePayload,
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${store.authToken}`,
              },
            }
          );
          revalidatedCaseStatus = revalRes.data?.casestatus || null;
          if (revalidatedCaseStatus) setRevalidatedStatus(revalidatedCaseStatus);
        } catch (revalErr) {
          console.warn('Revalidate dynamic data call failed (non-blocking):', revalErr.message);
        } finally {
          setRevalidating(false);
        }
      }

      // Payment proof updates + revalidation done — prompt user to confirm status change
      setPendingStatusKey(nextStatusKey);
      setRevalidateStatusMsg(
        blChanged || invChanged
          ? `BL / Invoice data has been validated.${revalidatedCaseStatus ? ` Case status: ${revalidatedCaseStatus}.` : ''}`
          : 'Payment details have been saved.'
      );
      setRevalidateConfirmStep('confirm');
    } catch (err) {
      console.error(`Error updating payment proof for case ${casenumber}:`, err.response?.data || err.message);
      setNotification({
        type: 'error',
        message: err.response?.data?.detail || 'Failed to update payment details.',
      });
      setTimeout(() => setNotification(null), 3000);
    } finally {
      setUpdatingStatus(false);
    }
  };

  // Submit only case status update
  const submitCaseStatusUpdate = async (nextStatusKey, comment, { closeModal = true } = {}) => {
    if (!nextStatusKey || !STATUS_ID_MAP[nextStatusKey]) {
      setNotification({ type: 'error', message: 'Invalid status.' });
      throw new Error('Invalid status');
    }

    const payload = {
      casenumber: casenumber,
      casestatusid: STATUS_ID_MAP[nextStatusKey],
      casestatusreason: comment || '',
      modifiedBy: parsedUserInfo?.email || parsedUserInfo?.userEmail,
      generateEmailPreview: false,
    };

    const response = await axios.put(
      `${CORE_URL}/update_case_status`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${store.authToken}`,
        },
      }
    );

    if (closeModal) {
      setModalOpen(false);
    }
    setCurrentStatus(nextStatusKey);
    updateStore({
      detailsStatus: nextStatusKey,
      promptQuery: `Show me the case details for ${response.data?.casenumber || casenumber}`,
      promptQueryNonce: (store.promptQueryNonce || 0) + 1,
      lastModifiedBy: parsedUserInfo?.email || parsedUserInfo?.userEmail || '',
    });
    updatePreviousViewStatus(response.data?.casenumber || casenumber);
    setNotification({ type: 'success', message: `Status updated to ${nextStatusKey}.` });
    setTimeout(() => setNotification(null), 3000);
    return response;
  };

  const renderCloseBlSelectionPanel = (introText) => {
    if (afrStatusCheck === 'loading') {
      return (
        <div style={{ textAlign: 'center', padding: '24px' }}>
          <McLoadingIndicator appearance="primary" />
          <p style={{ marginTop: '12px', fontSize: '14px', color: '#555' }}>
            Loading AFR task status for BL selection…
          </p>
        </div>
      );
    }

    if (afrStatusCheck?.status === 'found') {
      return (
        <div
          style={{
            margin: '12px auto',
            maxWidth: '520px',
            padding: '14px',
            backgroundColor: '#e3f2fd',
            borderRadius: '8px',
            border: '1px solid #90caf9',
            fontSize: '14px',
            color: '#1565c0',
            textAlign: 'left',
          }}
        >
          AFR task is already closed for this case in GCSS. Choose a different action or use Close AFR in GCSS to
          review closure details.
        </div>
      );
    }

    return (
      <div style={{ padding: '4px 0', textAlign: 'left' }}>
        <p style={{ fontSize: '14px', color: '#333', marginBottom: '10px', lineHeight: 1.45 }}>{introText}</p>
        {closeAfrEligibleBls.length > 0 && closeAfrSelectableBls.length === 0 ? (
          <div
            style={{
              padding: '14px',
              backgroundColor: '#fff8e1',
              borderRadius: '8px',
              border: '1px solid #ffcc80',
              fontSize: '14px',
              color: '#5d4037',
            }}
          >
            Every BL on this invoice is already recorded as closed. Nothing can be selected for another close.
          </div>
        ) : closeAfrEligibleBls.length > 0 ? (
          <div
            style={{
              backgroundColor: '#f7f7f7',
              borderRadius: '8px',
              padding: '14px 16px',
              border: '1px solid #e0e0e0',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
              <span style={{ fontSize: '13px', fontWeight: 600, color: '#555' }}>Bill of lading</span>
              <span style={{ fontSize: '12px' }}>
                <button
                  type="button"
                  onClick={() => setSelectedBlNumbersForClose([...closeAfrSelectableBls])}
                  disabled={closeAfrSelectableBls.length === 0}
                  style={{
                    marginRight: '10px',
                    background: 'none',
                    border: 'none',
                    color: closeAfrSelectableBls.length === 0 ? '#bbb' : '#1976d2',
                    cursor: closeAfrSelectableBls.length === 0 ? 'not-allowed' : 'pointer',
                    textDecoration: 'underline',
                  }}
                >
                  Select all
                </button>
                <button
                  type="button"
                  onClick={() => setSelectedBlNumbersForClose([])}
                  style={{ background: 'none', border: 'none', color: '#666', cursor: 'pointer', textDecoration: 'underline' }}
                >
                  Clear
                </button>
              </span>
            </div>
            <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
              {closeAfrEligibleBls.map((bl) => {
                const alreadyClosed = afrClosedBlNumbersFromStatus.has(bl);
                return (
                  <li
                    key={bl}
                    style={{
                      fontSize: '14px',
                      color: alreadyClosed ? '#888' : '#333',
                      padding: '8px 4px',
                      borderBottom: '1px solid #eee',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                    }}
                  >
                    <input
                      type="checkbox"
                      id={`compliant-gcss-bl-${bl}`}
                      disabled={alreadyClosed}
                      checked={!alreadyClosed && selectedBlNumbersForClose.includes(bl)}
                      onChange={() => toggleCloseBlSelection(bl)}
                    />
                    <label
                      htmlFor={`compliant-gcss-bl-${bl}`}
                      style={{ cursor: alreadyClosed ? 'default' : 'pointer', flex: 1 }}
                    >
                      {bl}
                      {alreadyClosed && (
                        <span style={{ marginLeft: '8px', fontSize: '12px', color: '#999' }}>
                          (already closed in GCSS)
                        </span>
                      )}
                    </label>
                  </li>
                );
              })}
            </ul>
            <p style={{ fontSize: '12px', color: '#888', marginTop: '10px', marginBottom: 0 }}>
              Only selected BL numbers will be sent to the GCSS close test API.
            </p>
          </div>
        ) : (
          <p style={{ fontSize: '13px', color: '#666', lineHeight: 1.45 }}>
            No BL numbers are listed on this invoice. The request will omit <code>blnumbers</code> so the API can
            process all eligible shipment BLs for the case.
          </p>
        )}
      </div>
    );
  };

  const updatePreviousViewStatus = (caseNum) => {
    try {
      const prev = store?.navigationHistory?.previousView;
      if (!prev?.data) return;
      const updatedRows = prev.data.map((r) => {
        const rowId = r?.casenumber || r?.case_number;
        if (String(rowId) === String(caseNum)) {
          return {
            ...r,
            casestatus: store?.detailsStatus || r.casestatus,
            modifiedby: store?.lastModifiedBy || r.modifiedby,
            casestatusreason: (store?.caseStatusReason !== undefined ? store.caseStatusReason : r.casestatusreason)
          };
        }
        return r;
      });
      updateStore({
        navigationHistory: {
          ...store.navigationHistory,
          previousView: { ...prev, data: updatedRows },
        },
      });
    } catch (e) {
      console.warn('Failed to patch previous view cache:', e);
    }
  };

  return (
    <div className="bl-details">
      <div className="step-indicator-wrapper">
        <McStepIndicator
          labels={[openStepLabel, casestatusWithModified, 'Total SLA']}
          currentindex={2}
        />
      </div>
      <div className="additional-buttons" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '20px' }}>
            <McButton
              label="Compose Email"
              icon="envelope"
              color="#ffff"
              fit="small"
              variant="filled"
              click={handleSendEmailMissingDocuments}
              disabled={false}
            />
          
          <McButton
            label="View Email History"
            icon="clock"
            color="#ffff"
            fit="small"
            variant="outlined"
            click={handleOpenEmailHistory}
          />
      {showCloseAfrInGcssButton && (
        <McButton
          label="Close AFR in GCSS"
          icon="lock-solid"
          fit="small"
          disabled={false}
          appearance="secondary"
          variant="filled"
          click={handleCloseAfrInGcss}
        />
      )}

        </div>
      {/* <div className="divider" style={{ marginTop: '20px' }}></div> */}
      <header className="bl-header">
        <span className="bl-title">
          {CASE_DETAILS_CONSTANTS.HEADERS.ASSOCIATED_BL_NO} &amp; Invoice
          Details Workflow
        </span>
        
        {normalizedStatus === 'OPEN' && (
          <div className="bl-actions" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <McButton
              appearance="secondary"
              fit="medium"
              disabled={processing}
              click={async () => {
                if (!casenumber) return;
                setProcessError("");
                //setProcessSuccess(false);
                setProcessing(true);
                try {
                  let billOfLading = "";
                  let invoiceNo = "";
                  if (Array.isArray(bldetails) && bldetails.length > 0) {
                    billOfLading = bldetails[0]?.blnumber || "";
                    const invs = bldetails[0]?.relatedInvoices || [];
                    if (Array.isArray(invs) && invs.length > 0) {
                      invoiceNo = invs[0] || "";
                    }
                  }
                  const formData = new FormData();
                  formData.append('case_number', casenumber || '');
                  if (billOfLading !== undefined) formData.append('bill_of_lading', billOfLading || '');
                  if (invoiceNo !== undefined) formData.append('invoice_no', invoiceNo || '');
                  const executedBy = parsedUserInfo?.email || parsedUserInfo?.userEmail;
                  if (executedBy) formData.append('executed_by', executedBy);
                  const response = await fetch(`${CORE_URL}/process-afr-data`, { method: 'POST', body: formData });
                  if (!response.ok) {
                    const text = await response.text();
                    throw new Error(text || `Failed with status ${response.status}`);
                  }
                  const data = await response.json().catch(() => ({}));
                  if (data.afr_processing_status) {
                    setCurrentStatus(data.afr_processing_status);
                    updateStore({ 
                      detailsStatus: data.afr_processing_status, 
                      promptQuery: `Show me the case details for ${casenumber}`,
                      lastModifiedBy: parsedUserInfo?.email || parsedUserInfo?.userEmail || ''
                    });
                    // Refresh previous view cache for back navigation consistency
                    updatePreviousViewStatus(casenumber);
                  }
                  if (data.afr_status_reason) {
                    setStatusReason(data.afr_status_reason);
                    updateStore({ caseStatusReason: data.afr_status_reason });
                  } else {
                    setStatusReason(null);
                    updateStore({ caseStatusReason: "" });
                  }

                  
                } catch (e) {
                  setProcessError(e.message || 'Failed to start processing');
                } finally {
                  setProcessing(false);
                }
              }}
            >
              {processing ? 'Processing...' : 'Start Processing'}
            </McButton>
            {processError && (
              <div style={{ color: 'red', marginTop: '4px', fontSize: '12px' }}>{processError}</div>
            )}
            {processing && (
              <div style={{ marginTop: '6px' }}>
                <McLoadingIndicator appearance="primary" />
              </div>
            )}
            {statusReason && (
              <div style={{ color: '#555', marginTop: '4px', fontSize: '12px' }}>Reason: {statusReason}</div>
            )}
          </div>
        )}
       {normalizedStatus !== 'OPEN' && normalizedStatus !== 'APPROVED' && (
        <div className="bl-actions" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <McButton
            appearance="secondary"
            fit="medium"
            click={() => { setSelectedAction(""); setModalOpen(true); }}
          >
            Please select the next action
          </McButton>
        </div>
      )}
      </header>



        {notification && (
        <McNotification
          type={notification.type}
          body={notification.message}
          position="top-center"
          autoclose
          closable
          style={{ backgroundColor: notification.type === 'success' ? 'green' : 'red' }}
        />
      )}
      {normalizedStatus !== 'OPEN' && (
      <NextStepModal
        onClose={handleModalClose}
        open={modalOpen}
        width="50vw"
        height={(() => {
          const action = (selectedAction || '').toLowerCase();
          if (action === 'approve') {
            if (revalidateConfirmStep === 'confirm') return '52vh';
            if (revalidateConfirmStep === 'comments') return '40vh';
            return popDocuments.some(p => p.expanded) ? '85vh' : '65vh';
          }
          if (action === 'compliant-gcss') return '72vh';
          if (['reject','non-compliant'].includes(action)) return '60vh';
          return '50vh';
        })()}
      >
        <div className="nextActioncontent">
         {(
            <McSelect
              label=""
              placeholder="Select an action"
              value={selectedAction}
              optionselected={(e) => setSelectedAction(e.target.value)}
            > {normalizedStatus === "ON-HOLD" ? (
              <>
                <McOption value="COMPLIANT">Compliant</McOption>
                <McOption value={ACTION_COMPLIANT_GCSS}>
                  <span className="compliant-gcss-option-label">
                    Compliant &amp; GCSS Closure
                    <McTag label="New" appearance="info" fit="small" />
                  </span>
                </McOption>
                <McOption value="NON-COMPLIANT">Non-Compliant</McOption>
                <McOption value="EXCEPTION">Exception</McOption>
                <McOption value="NON-AFR">Non-AFR</McOption>
              </>
            ) : normalizedStatus === "COMPLIANT" ? (
              <>
                <McOption value="approve">Approve</McOption>
                <McOption value="reject">Reject</McOption>
                <McOption value="non-compliant">Non-compliant</McOption>
                  <McOption value="NON-AFR">Non-AFR</McOption>
              </>
            ) : normalizedStatus === "NON-COMPLIANT" ? (
              <>
              <McOption value="ON-HOLD">On-hold</McOption>
                <McOption value="approve">Approve</McOption>
                <McOption value="reject">Reject</McOption>
                <McOption value="compliant">Compliant</McOption>
                  <McOption value="NON-AFR">Non-AFR</McOption>
              </>
            ) : normalizedStatus === "REJECTED" ? (
              <>
              <McOption value="ON-HOLD">On-hold</McOption>
                <McOption value="approve">Approve</McOption>
                <McOption value="compliant">Compliant</McOption>
                  <McOption value="NON-AFR">Non-AFR</McOption>
              </>
            ) :
            (
              <>
                <McOption value="approve">Approve</McOption>
                <McOption value="reject">Reject</McOption>
                <McOption value="NON-AFR">Non-AFR</McOption>
              </>
            )}
          </McSelect>
          )}
          {( (selectedAction || '').toLowerCase() === 'reject' || (selectedAction || '').toLowerCase() === 'non-compliant') && (
            <div style={{ marginTop: '12px' }}>
              <label style={{ fontSize: '16px', fontWeight: 400, display: 'block', marginBottom: '4px' }}>Reasons</label>
              <div style={{  border: '1px solid #d0d0d0', borderRadius: '4px', padding: '6px' }}>
                {reasonOptions.map(option => (
                  <div key={option} style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                    <input
                      id={`reason-${option}`}
                      type="checkbox"
                      checked={rejectReasons.includes(option)}
                      onChange={() => toggleReason(option)}
                      style={{ marginRight: '6px' }}
                      disabled={ option != 'Other' && rejectReasons.length > 0 && rejectReasons.includes('Other')}
                    />
                    <label htmlFor={`reason-${option}`} style={{ fontSize: '12px', cursor: 'pointer' }}>{option}</label>
                  </div>
                ))}
              </div>
            </div>
          )}
          {( ((selectedAction || '').toLowerCase() === 'reject' || (selectedAction || '').toLowerCase() === 'non-compliant') && rejectReasons.includes('Other')) && (
            <textarea
              rows={4}
              style={{ width: "-webkit-fill-available", marginTop: "8px" }}
              name="customRejectReason"
              value={customRejectText}
              onChange={(e) => setCustomRejectText(e.target.value)}
              placeholder="Enter reason"
            />
          )}
          {((selectedAction || '').toLowerCase() === 'approve') && revalidateConfirmStep === null && (
            <div style={{ marginTop: '16px' }}>
              {/* Loading Indicator */}
              {loadingPaymentProof && (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                  <McLoadingIndicator appearance="primary" />
                  <p style={{ marginTop: '8px', fontSize: '13px', color: '#666' }}>Loading payment proof details...</p>
                </div>
              )}
              
              {!loadingPaymentProof && (
                <>
                  {/* Shared BL Number & Invoice Number at top */}
                  <div style={{ marginBottom: '16px', padding: '14px', backgroundColor: '#f9f9f9', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                      <div>
                        <label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>BL Number <span style={{ color: '#999', fontSize: '12px' }}>(9 alphanumeric)</span></label>
                        <input type="text" value={sharedBlNumber}
                          onChange={(e) => { setSharedBlNumber(e.target.value); setSharedBlNumberError(validateBlNumber(e.target.value)); }}
                          placeholder="Enter BL Number(s), e.g. ABC123456, XYZ789012"
                          style={{ ...getFieldStyle(sharedBlNumber), borderColor: sharedBlNumberError ? '#d32f2f' : '#d0d0d0', backgroundColor: sharedBlNumberError ? '#ffebee' : (isFieldFilled(sharedBlNumber) ? '#f0f8ff' : 'transparent') }} />
                        {sharedBlNumberError && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '4px', fontWeight: 500 }}>{sharedBlNumberError}</div>}
                      </div>
                      <div>
                        <label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Invoice Number</label>
                        <input type="text" value={sharedInvoiceNumber} onChange={(e) => setSharedInvoiceNumber(e.target.value)} style={getFieldStyle(sharedInvoiceNumber)} />
                      </div>
                    </div>
                  </div>

                  {/* POP Documents — one expandable section per POP */}
                  {popDocuments.map((pop, popIdx) => (
                    <div key={popIdx} style={{ marginBottom: '12px', backgroundColor: '#f9f9f9', borderRadius: '8px', border: '1px solid #e0e0e0', overflow: 'hidden' }}>
                      {/* Header — "Proof of Payment" with Payee/Beneficiary summary */}
                      <div style={{ padding: '16px 20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                          <h4 style={{ margin: 0, fontSize: '15px', fontWeight: 400, color: '#141414' }}>
                            <span style={{ fontWeight: 700 }}>Proof of Payment:</span>{' '}
                            {pop.proofdocumentpath || <span style={{ color: '#999' }}>&mdash;</span>}
                          </h4>
                          {getFilledPopFieldsCount(pop) > 0 && (
                            <div style={{ backgroundColor: '#4caf50', color: 'white', borderRadius: '12px', padding: '2px 8px', fontSize: '11px', fontWeight: 600 }}>
                              {getFilledPopFieldsCount(pop)} of 8 filled
                            </div>
                          )}
                        </div>
                        <div style={{ fontSize: '14px', color: '#555', marginBottom: '10px' }}>
                          <span style={{ fontSize: '15px', fontWeight: 700, color: pop.documenttype?.toLowerCase() === 'unqualified-pop' ? ' #EA5D4B' : '#141414' }}>Document Type : {pop.documenttype || <span style={{ color: '#999' }}>&mdash;</span>}</span>
                        </div>
                        <div style={{ display: 'flex', gap: '40px', flexWrap: 'wrap' }}>
                          <div style={{ flex: 1, minWidth: '200px' }}>
                            <div style={{ fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '6px' }}>Payer Information</div>
                            <div style={{ fontSize: '12px', color: '#555', lineHeight: 1.8 }}>
                              <div><strong>Payer Name :</strong> {pop.payerName || <span style={{ color: '#999' }}>&mdash;</span>}</div>
                              <div><strong>Country :</strong> {country || <span style={{ color: '#999' }}>&mdash;</span>}</div>
                            </div>
                          </div>
                          <div style={{ flex: 1, minWidth: '200px' }}>
                            <div style={{ fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '6px' }}>Beneficiary Information</div>
                            <div style={{ fontSize: '12px', color: '#555', lineHeight: 1.8 }}>
                              <div><strong>Beneficiary Name :</strong> {pop.beneficiaryName || beneficiaryname || <span style={{ color: '#999' }}>&mdash;</span>}</div>
                              <div><strong>Bank Account No. (IBAN) :</strong> {pop.bankAccountNumber || beneficiaryaccount || <span style={{ color: '#999' }}>&mdash;</span>}</div>
                              <div><strong>Amount in Payment Proof :</strong> {pop.amountInPaymentProof || <span style={{ color: '#999' }}>&mdash;</span>}</div>
                              <div><strong>Currency :</strong> {pop.currencyInPaymentProof || popcurrency || <span style={{ color: '#999' }}>&mdash;</span>}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Collapsible "POP Document N" toggle */}
                      <div
                        role="button"
                        tabIndex={0}
                        onClick={() => togglePopExpanded(popIdx)}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); togglePopExpanded(popIdx); } }}
                        style={{
                          padding: '10px 20px', backgroundColor: pop.documenttype?.toLowerCase() === 'unqualified-pop' ? '#FFE9E7' : '#f0f0f0', cursor: 'pointer',
                          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                          userSelect: 'none', borderTop: '1px solid #e0e0e0',
                          borderBottom: pop.expanded ? '1px solid #e0e0e0' : 'none'
                        }}
                      ><span style={{ fontSize: '13px', fontWeight: 500, color: '#333' }}>{pop.documenttype?.toLowerCase() === 'unqualified-pop' ? 'Unqualified POP' : 'Qualified POP'} {popIdx + 1}</span>
                        
                        <svg width="18" height="18" viewBox="0 0 24 24"
                          style={{ transform: pop.expanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }}>
                          <path d="M7 10l5 5 5-5" stroke="#555" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>

                      {/* Expandable POP-specific fields (8 fields) */}
                      {pop.expanded && (
                        <div style={{ padding: '12px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', maxHeight: '50vh', overflowY: 'auto' }}>
                          <div>
                            <label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Payment Proof Ref #</label>
                            <input type="text" value={pop.paymentProofRef} onChange={(e) => updatePopField(popIdx, 'paymentProofRef', e.target.value)} style={getFieldStyle(pop.paymentProofRef)} />
                          </div>
                          <div>
                            <label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Payment Proof Date</label>
                            <input type="date" value={pop.paymentProofDate} onChange={(e) => updatePopField(popIdx, 'paymentProofDate', e.target.value)} style={getFieldStyle(pop.paymentProofDate)} />
                          </div>
                          <div>
                            <label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Amount in Payment Proof</label>
                            <input type="number" step="0.01" value={pop.amountInPaymentProof} onChange={(e) => updatePopField(popIdx, 'amountInPaymentProof', e.target.value)} style={getFieldStyle(pop.amountInPaymentProof)} />
                          </div>
                          <div>
                            <label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Currency</label>
                            <input type="text" value={pop.currencyInPaymentProof} onChange={(e) => updatePopField(popIdx, 'currencyInPaymentProof', e.target.value.toUpperCase())} style={getFieldStyle(pop.currencyInPaymentProof)} />
                          </div>
                          <div>
                            <label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Beneficiary Name</label>
                            <input type="text" value={pop.beneficiaryName} onChange={(e) => updatePopField(popIdx, 'beneficiaryName', e.target.value)} style={getFieldStyle(pop.beneficiaryName)} />
                          </div>
                          <div>
                            <label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Bank Account Number</label>
                            <input type="text" value={pop.bankAccountNumber} onChange={(e) => updatePopField(popIdx, 'bankAccountNumber', e.target.value)} style={getFieldStyle(pop.bankAccountNumber)} />
                          </div>
                          <div>
                            <label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Payer Name</label>
                            <input type="text" value={pop.payerName} onChange={(e) => updatePopField(popIdx, 'payerName', e.target.value)} style={getFieldStyle(pop.payerName)} />
                          </div>
                          <div>
                            <label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Tax ID Number / NIT</label>
                            <input type="text" value={pop.taxIdNumber} onChange={(e) => updatePopField(popIdx, 'taxIdNumber', e.target.value)} style={getFieldStyle(pop.taxIdNumber)} />
                          </div>
                          {/* Supporting document preview — full width */}
                          <div style={{ gridColumn: '1 / -1', marginTop: '8px', borderTop: '1px solid #e0e0e0', paddingTop: '12px' }}>
                            <label style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '8px', color: '#555' }}>Supporting Document</label>
                            {(() => {
                              const filename = (pop.proofdocumentpath || '').trim();
                              if (!filename) return (
                                <p style={{ fontSize: '13px', color: '#888', margin: 0 }}>No supporting document available</p>
                              );
                              const ext = filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase();
                              const fileUrl = `${GET_FILE_API(casenumber)}/${encodeURIComponent(filename)}`;
                              const RENDERER_MAP = { pdf: renderPdf, docx: renderDocx, png: renderImage, jpg: renderImage, jpeg: renderImage };
                              const renderer = RENDERER_MAP[ext];
                              if (renderer) return renderer(fileUrl, filename);
                              return (
                                <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: '13px', color: '#1976d2', textDecoration: 'underline', wordBreak: 'break-all' }}>
                                  {filename}
                                </a>
                              );
                            })()}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </>
              )}
            </div>
          )}
          {/* Approve: confirmation popup step — shown after payment proof saved + revalidate */}
          {(selectedAction || '').toLowerCase() === 'approve' && revalidateConfirmStep === 'confirm' && (
            <div style={{ marginTop: '24px', padding: '24px 20px', backgroundColor: '#f0f8ff', borderRadius: '10px', border: '1px solid #90caf9', textAlign: 'center' }}>
              <div style={{ fontSize: '32px', marginBottom: '10px' }}>✅</div>
              <p style={{ fontSize: '15px', fontWeight: 600, color: '#1a237e', marginBottom: '6px' }}>Payment details saved successfully.</p>
              {revalidateStatusMsg && (
                <p style={{ fontSize: '13px', color: '#555', marginBottom: '14px' }}>{revalidateStatusMsg}</p>
              )}
              <p style={{ fontSize: '14px', color: '#333', marginBottom: '22px' }}>
                Do you want to proceed and update the case status to <strong>APPROVED</strong>?
              </p>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                <McButton appearance="primary" fit="medium" click={() => { if (!comments) setComments('AFR closed'); setRevalidateConfirmStep('comments'); }}>
                  Yes, Proceed
                </McButton>
                <McButton appearance="neutral" variant="filled" fit="medium" click={handleModalClose}>
                  Cancel
                </McButton>
              </div>
            </div>
          )}

          {/* Approve: comments entry step — shown after user clicks Yes */}
          {(selectedAction || '').toLowerCase() === 'approve' && revalidateConfirmStep === 'comments' && (
            <div style={{ marginTop: '16px' }}>
              <p style={{ fontSize: '13px', color: '#555', marginBottom: '6px' }}>Add any comments for this approval (optional).</p>
              <textarea
                rows={5}
                style={{ width: '-webkit-fill-available', marginTop: '0px' }}
                name="additionalComments"
                value={comments || ''}
                onChange={(e) => setComments(e.target.value)}
                placeholder="Enter Comments for Status change"
              />
            </div>
          )}

          {(selectedAction || '').toUpperCase() === ACTION_COMPLIANT_GCSS &&
            renderCloseBlSelectionPanel(
              'This will mark the case Compliant, then run the GCSS close test flow for the BL number(s) you select below.'
            )}
          {( ((selectedAction || '').toLowerCase() === 'compliant' || (selectedAction || '').toLowerCase() === 'on-hold' ||  (selectedAction || '').toLowerCase() === 'exception' || (selectedAction || '').toLowerCase() === 'non-afr')) && (
            <textarea
              rows={5}
              style={{ width: "-webkit-fill-available", marginTop: '0px' }}
              name="additionalComments"
              value={comments || ""}
              onChange={(e) => setComments(e.target.value)}
              placeholder="Enter Comments for Status change"
            />
          )}
          {(selectedAction || '').toUpperCase() === ACTION_COMPLIANT_GCSS && (
            <textarea
              rows={3}
              style={{ width: '-webkit-fill-available', marginTop: '0px' }}
              name="compliantGcssComments"
              value={comments || ''}
              onChange={(e) => setComments(e.target.value)}
              placeholder={DEFAULT_COMPLIANT_GCSS_COMMENT}
            />
          )}
          {revalidateConfirmStep !== 'confirm' && (
          <div className="submitButton" style={{ marginTop: '12px' }}>
            <McButton
              appearance="secondary"
              fit="medium"
              disabled={
                updatingStatus ||
                !!sharedBlNumberError ||
                ((selectedAction || '').toLowerCase() === 'approve' && loadingPaymentProof && revalidateConfirmStep === null) ||
                ((selectedAction || '').toUpperCase() === ACTION_COMPLIANT_GCSS &&
                  (afrStatusCheck === 'loading' ||
                    afrStatusCheck?.status === 'found' ||
                    (closeAfrSelectableBls.length > 0 && selectedBlNumbersForClose.length === 0)))
              }
              click={() => handleCaseStatusSubmit()}
            >
              {revalidating
                ? 'Revalidating data, please wait...'
                : updatingStatus
                  ? 'Submitting...'
                  : revalidateConfirmStep === 'comments'
                    ? 'Approve'
                    : (selectedAction || '').toUpperCase() === ACTION_COMPLIANT_GCSS
                      ? 'Submit Compliant & GCSS Closure'
                      : 'Submit'}
            </McButton>
            {updatingStatus && !revalidating && (
              <div style={{ marginTop: '8px' }}>
                <McLoadingIndicator appearance="primary" />
              </div>
            )}
            {revalidating && (
              <p style={{ fontSize: '12px', color: '#555', marginTop: '6px' }}>
                Revalidating BL / Invoice data, this may take up a few seconds&hellip;
              </p>
            )}
          </div>
          )}
        </div>
        {/* <div className="bl-actions">
            <button
              type="button"
              onClick={handleApprove}
              className="action-btn approve-btn"
            >
              Approve
            </button>
            <button
              type="button"
              className="action-btn reject-btn"
            >
              Reject
            </button>
          </div> */}
  </NextStepModal>
  )}
  <EmailPreviewModal
    isOpen={isEmailModalOpen}
    onClose={handleEmailModalClose}
    caseNumber={casenumber}
    country={country}
    missingFields={missingFields}
    onEmailSent={handleEmailSent}
  />
  <EmailHistoryModal
    isOpen={isEmailHistoryModalOpen}
    onClose={handleCloseEmailHistory}
    caseNumber={casenumber}
  />
  
  {/* Close AFR in GCSS Modal */}
  <McModal
    heading={afrCloseResult?.bl_results && Object.values(afrCloseResult.bl_results).some((r) => typeof r === 'object' && r?.status === 'would_close')
      ? 'GCSS Close Test Results'
      : 'Close AFR Task in GCSS'}
    closed={handleCloseAfrModal}
    open={isCloseAfrModalOpen}
    width="60vw"
    height={!afrCloseResult && !closingAfr ? '70vh' : '70vh'}
  >
    <div style={{ padding: '20px', maxHeight: '62vh', overflowY: 'auto' }}>
      {/* Phase 1: Checking AFR task status */}
      {afrStatusCheck === 'loading' && !afrCloseResult && !closingAfr && (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <McLoadingIndicator appearance="primary" />
          <p style={{ marginTop: '20px', fontSize: '16px', color: '#333' }}>Checking AFR task status for case {casenumber}...</p>
        </div>
      )}

      {/* Phase 2: Already closed — show existing record */}
      {afrStatusCheck && afrStatusCheck !== 'loading' && afrStatusCheck.status === 'found' && !afrCloseResult && !closingAfr && (
        <div style={{ padding: '20px' }}>
          <div style={{ padding: '16px', backgroundColor: '#e3f2fd', borderRadius: '8px', borderLeft: '4px solid #1976d2', marginBottom: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
              <svg width="24" height="24" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="11" fill="#1976d2" stroke="none" />
                <path d="M7 12.5l3 3 7-7" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span style={{ fontSize: '16px', fontWeight: 600, color: '#1976d2' }}>
                AFR task is already closed for this case
              </span>
            </div>
            <p style={{ fontSize: '13px', color: '#555', margin: 0 }}>
              The AFR task for case <strong>{casenumber}</strong> has already been closed in GCSS. No further action is needed.
            </p>
          </div>

          <div style={{ backgroundColor: '#f7f7f7', borderRadius: '8px', padding: '16px' }}>
            <h4 style={{ fontSize: '15px', fontWeight: 600, marginBottom: '12px', color: '#141414' }}>Closure Details</h4>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
              <tbody>
                <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                  <td style={{ padding: '10px 12px', fontWeight: 600, color: '#555', width: '40%' }}>Case Number</td>
                  <td style={{ padding: '10px 12px', color: '#333' }}>{afrStatusCheck.data?.case_number}</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                  <td style={{ padding: '10px 12px', fontWeight: 600, color: '#555' }}>BL Numbers</td>
                  <td style={{ padding: '10px 12px', color: '#333' }}>
                    {afrStatusCheck.data?.bl_numbers ? (
                      <ul style={{ margin: 0, paddingLeft: '18px', listStyleType: 'disc' }}>
                        {afrStatusCheck.data.bl_numbers.split(',').map((bl, i) => (
                          <li key={i} style={{ padding: '2px 0' }}>{bl.trim()}</li>
                        ))}
                      </ul>
                    ) : 'N/A'}
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                  <td style={{ padding: '10px 12px', fontWeight: 600, color: '#555' }}>Task Name</td>
                  <td style={{ padding: '10px 12px', color: '#333' }}>{afrStatusCheck.data?.task_name || 'N/A'}</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                  <td style={{ padding: '10px 12px', fontWeight: 600, color: '#555' }}>Task Status</td>
                  <td style={{ padding: '10px 12px' }}>
                    <McTag label={afrStatusCheck.data?.task_status || 'CLOSED'} appearance="success" />
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                  <td style={{ padding: '10px 12px', fontWeight: 600, color: '#555' }}>Closed By</td>
                  <td style={{ padding: '10px 12px', color: '#333' }}>{afrStatusCheck.data?.modified_by || 'N/A'}</td>
                </tr>
                <tr>
                  <td style={{ padding: '10px 12px', fontWeight: 600, color: '#555' }}>Closed At</td>
                  <td style={{ padding: '10px 12px', color: '#333' }}>
                    {afrStatusCheck.data?.modified_datetime
                      ? new Date(afrStatusCheck.data.modified_datetime).toLocaleString()
                      : 'N/A'}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Phase 3: Not fully closed — pick open BL(s); already-closed BLs disabled (from fresh afr_task_status each open) */}
      {afrStatusCheck && afrStatusCheck !== 'loading' && afrStatusCheck.status !== 'found' && !afrCloseResult && !closingAfr && (
        <div style={{ padding: '12px 8px' }}>
          <p style={{ fontSize: '16px', color: '#333', marginBottom: '12px', textAlign: 'center' }}>
            Select BL number(s) to close in GCSS for case <strong>{casenumber}</strong>, then confirm.
          </p>
          <p style={{ fontSize: '12px', color: '#666', marginBottom: '12px', textAlign: 'center', lineHeight: 1.45 }}>
            AFR task status is checked each time you open this dialog. BLs already closed in GCSS cannot be selected.
          </p>
          {closeAfrEligibleBls.length > 0 && closeAfrSelectableBls.length === 0 ? (
            <div
              style={{
                margin: '12px auto',
                maxWidth: '480px',
                padding: '16px',
                backgroundColor: '#fff8e1',
                borderRadius: '8px',
                border: '1px solid #ffcc80',
                fontSize: '14px',
                color: '#5d4037',
              }}
            >
              Every BL listed on this invoice is already recorded as closed for this case. Nothing here can be selected
              for another close. If you expected an open BL, reopen this dialog after data refresh or check other
              shipment BLs outside this list.
            </div>
          ) : closeAfrEligibleBls.length > 0 ? (
            <div
              style={{
                margin: '12px auto',
                maxWidth: '480px',
                textAlign: 'left',
                backgroundColor: '#f7f7f7',
                borderRadius: '8px',
                padding: '14px 16px',
                border: '1px solid #e0e0e0',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span style={{ fontSize: '13px', fontWeight: 600, color: '#555' }}>Bill of lading</span>
                <span style={{ fontSize: '12px' }}>
                  <button
                    type="button"
                    onClick={() => setSelectedBlNumbersForClose([...closeAfrSelectableBls])}
                    disabled={closeAfrSelectableBls.length === 0}
                    style={{
                      marginRight: '10px',
                      background: 'none',
                      border: 'none',
                      color: closeAfrSelectableBls.length === 0 ? '#bbb' : '#1976d2',
                      cursor: closeAfrSelectableBls.length === 0 ? 'not-allowed' : 'pointer',
                      textDecoration: 'underline',
                    }}
                  >
                    Select all
                  </button>
                  <button
                    type="button"
                    onClick={() => setSelectedBlNumbersForClose([])}
                    style={{ background: 'none', border: 'none', color: '#666', cursor: 'pointer', textDecoration: 'underline' }}
                  >
                    Clear
                  </button>
                </span>
              </div>
              <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                {closeAfrEligibleBls.map((bl) => {
                  const alreadyClosed = afrClosedBlNumbersFromStatus.has(bl);
                  return (
                    <li
                      key={bl}
                      style={{
                        fontSize: '14px',
                        color: alreadyClosed ? '#888' : '#333',
                        padding: '8px 4px',
                        borderBottom: '1px solid #eee',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                      }}
                    >
                      <input
                        type="checkbox"
                        id={`close-afr-bl-${bl}`}
                        disabled={alreadyClosed}
                        checked={!alreadyClosed && selectedBlNumbersForClose.includes(bl)}
                        onChange={() => toggleCloseBlSelection(bl)}
                      />
                      <label
                        htmlFor={`close-afr-bl-${bl}`}
                        style={{ cursor: alreadyClosed ? 'default' : 'pointer', flex: 1 }}
                      >
                        {bl}
                        {alreadyClosed && (
                          <span style={{ marginLeft: '8px', fontSize: '12px', color: '#999' }}>
                            (already closed in GCSS)
                          </span>
                        )}
                      </label>
                    </li>
                  );
                })}
              </ul>
              <p style={{ fontSize: '12px', color: '#888', marginTop: '10px', marginBottom: 0 }}>
                Only the selected BL numbers will be closed in GCSS.
              </p>
            </div>
          ) : (
            <p style={{ fontSize: '13px', color: '#666', textAlign: 'center', marginTop: '8px' }}>
              No BL numbers are listed on this invoice view. The request will omit <code>blnumbers</code> so the API can close all eligible shipment BLs for the case.
            </p>
          )}
        </div>
      )}

      {/* Loading state — closing in progress */}
      {closingAfr && (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <McLoadingIndicator appearance="primary" />
          <p style={{ marginTop: '20px', fontSize: '16px', color: '#333' }}>Processing AFR closure for case {casenumber}...</p>
        </div>
      )}

      {/* Results after API call */}
      {!closingAfr && afrCloseResult && (
        <>
          <p style={{ fontSize: '14px', color: '#555', marginBottom: '16px', lineHeight: 1.5 }}>
            Your close request was sent. Review the case summary and each bill of lading result below.
          </p>
          {/* Case Summary */}
          {afrCloseResult && (
            <div style={{ marginBottom: '24px', padding: '16px', backgroundColor: '#f7f7f7', borderRadius: '8px', borderLeft: '4px solid #42b0d5' }}>
              <h3 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px', color: '#141414' }}>
                Case: {casenumber}
              </h3>
              <div style={{ display: 'flex', gap: '24px', fontSize: '14px', color: '#555' }}>
                <span><strong>Shipment Type:</strong> {afrCloseResult.shipment_type || 'N/A'}</span>
                <span><strong>Case Status:</strong> {afrCloseResult.case_status || 'N/A'}</span>
              </div>
            </div>
          )}

          {/* BL Processing Results */}
          {afrCloseResult?.bl_results && Object.keys(afrCloseResult.bl_results).length > 0 && (
            <div>
              <h4 style={{ fontSize: '15px', fontWeight: 600, marginBottom: '12px', color: '#141414' }}>
                BL Processing Results ({Object.keys(afrCloseResult.bl_results).length} BL{Object.keys(afrCloseResult.bl_results).length > 1 ? 's' : ''})
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {Object.entries(afrCloseResult.bl_results).map(([blNumber, result]) => {
                  const isSkipped = typeof result === 'string';
                  const isAlreadyClosed = isSkipped && result.toLowerCase().includes('task status is closed');
                  const isPrereqFail = isSkipped && result.toLowerCase().includes('prerequisites not closed');
                  const isSuccess = !isSkipped && (result.status === 'closed' || result.status === 'would_close');
                  const isFailed = !isSkipped && (result.status === 'failed' || result.status === 'error');

                  const blLogs = afrExecutionLogs.filter(l => l.includes(`-${blNumber}`) && l.match(/\[STEP [56]-/));
                  const prereqLogs = blLogs.filter(l => l.includes('-A]'));
                  const taskLogs = blLogs.filter(l => l.includes('-B]'));
                  const gcssResponse = !isSkipped ? result.gcss_api_call?.response : null;
                  const gcssDebugMsg = gcssResponse?.body?.debugMessage;

                  let tagLabel, tagAppearance;
                  if (isSuccess) {
                    tagLabel = result.status === 'would_close' ? 'Would Close (test)' : 'Closed';
                    tagAppearance = 'success';
                  }
                  else if (isAlreadyClosed) { tagLabel = 'Already Closed'; tagAppearance = 'info'; }
                  else if (isPrereqFail) { tagLabel = 'Skipped'; tagAppearance = 'warning'; }
                  else if (isSkipped) { tagLabel = 'Skipped'; tagAppearance = 'warning'; }
                  else { tagLabel = 'Failed'; tagAppearance = 'error'; }

                  return (
                    <details key={blNumber} style={{ border: '1px solid #e0e0e0', borderRadius: '6px', overflow: 'hidden' }}>
                      <summary style={{ padding: '12px 16px', cursor: 'pointer', backgroundColor: '#f7f7f7', listStyle: 'none', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <span style={{ fontWeight: 500, fontSize: '14px' }}>BL: {blNumber}</span>
                          <McTag label={tagLabel} appearance={tagAppearance} />
                        </div>
                        <span style={{ fontSize: '12px', color: '#888' }}>&#9660;</span>
                      </summary>
                      <div style={{ padding: '16px' }}>
                        {/* Skipped BL — show reason directly */}
                        {isSkipped && (
                          <div style={{ padding: '12px', borderRadius: '6px', backgroundColor: isAlreadyClosed ? '#e3f2fd' : '#fff8e1', border: `1px solid ${isAlreadyClosed ? '#90caf9' : '#ffe082'}` }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                              <svg width="20" height="20" viewBox="0 0 24 24">
                                {isAlreadyClosed ? (
                                  <>
                                    <circle cx="12" cy="12" r="11" fill="#1976d2" stroke="none" />
                                    <path d="M7 12.5l3 3 7-7" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                  </>
                                ) : (
                                  <>
                                    <circle cx="12" cy="12" r="11" fill="#f9a825" stroke="none" />
                                    <path d="M12 7v6" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
                                    <circle cx="12" cy="16.5" r="1.2" fill="#fff" />
                                  </>
                                )}
                              </svg>
                              <span style={{ fontSize: '14px', fontWeight: 600, color: isAlreadyClosed ? '#1976d2' : '#f57f17' }}>
                                {isAlreadyClosed ? 'AFR task is already closed for this BL' : result}
                              </span>
                            </div>
                          </div>
                        )}

                        {/* Non-skipped BL — show full details */}
                        {!isSkipped && (
                          <>
                            {/* Prerequisite Checks */}
                            <div style={{ marginBottom: '16px' }}>
                              <div style={{ fontSize: '13px', fontWeight: 600, color: '#141414', marginBottom: '8px', paddingBottom: '4px', borderBottom: '1px solid #e0e0e0' }}>
                                Prerequisite Checks
                              </div>
                              {prereqLogs.length > 0 ? prereqLogs.map((log, idx) => {
                                const isFail = log.includes('FAILED') || log.includes('ERROR');
                                const taskName = log.replace(/.*Prerequisite (OK|FAILED|ERROR):\s*/, '').trim();
                                return (
                                  <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '5px 0' }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
                                      {isFail ? (
                                        <circle cx="12" cy="12" r="11" fill="#d32f2f" stroke="none" />
                                      ) : (
                                        <circle cx="12" cy="12" r="11" fill="#2e7d32" stroke="none" />
                                      )}
                                      {isFail ? (
                                        <path d="M8 8l8 8M16 8l-8 8" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
                                      ) : (
                                        <path d="M7 12.5l3 3 7-7" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                      )}
                                    </svg>
                                    <span style={{ fontSize: '13px', color: '#333' }}>{taskName || log.replace(/\[STEP.*?\]\s*/, '')}</span>
                                  </div>
                                );
                              }) : (
                                <div style={{ fontSize: '13px', color: '#888', padding: '4px 0' }}>No prerequisite data</div>
                              )}
                            </div>

                            {/* AFR Task Status */}
                            {taskLogs.length > 0 && (
                              <div style={{ marginBottom: '16px' }}>
                                <div style={{ fontSize: '13px', fontWeight: 600, color: '#141414', marginBottom: '8px', paddingBottom: '4px', borderBottom: '1px solid #e0e0e0' }}>
                                  AFR Task
                                </div>
                                {taskLogs.map((log, idx) => {
                                  const statusMatch = log.match(/status:\s*(\w+)/i);
                                  const taskStatus = statusMatch ? statusMatch[1] : '';
                                  return (
                                    <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '5px 0' }}>
                                      <svg width="18" height="18" viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
                                        <circle cx="12" cy="12" r="11" fill="#1976d2" stroke="none" />
                                        <path d="M8 12h8" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
                                        <path d="M12 8v8" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
                                      </svg>
                                      <span style={{ fontSize: '13px', color: '#333' }}>
                                        AFR task found — Status: <strong>{taskStatus}</strong>
                                      </span>
                                    </div>
                                  );
                                })}
                              </div>
                            )}

                            {/* GCSS API Response */}
                            <div>
                              <div style={{ fontSize: '13px', fontWeight: 600, color: '#141414', marginBottom: '8px', paddingBottom: '4px', borderBottom: '1px solid #e0e0e0' }}>
                                GCSS API Response
                              </div>
                              <div style={{ padding: '12px', borderRadius: '6px', backgroundColor: isSuccess ? '#f1f8f4' : '#fef5f5', border: `1px solid ${isSuccess ? '#c8e6c9' : '#ffcdd2'}` }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
                                  <svg width="20" height="20" viewBox="0 0 24 24">
                                    {isSuccess ? (
                                      <>
                                        <circle cx="12" cy="12" r="11" fill="#2e7d32" stroke="none" />
                                        <path d="M7 12.5l3 3 7-7" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                      </>
                                    ) : (
                                      <>
                                        <circle cx="12" cy="12" r="11" fill="#d32f2f" stroke="none" />
                                        <path d="M8 8l8 8M16 8l-8 8" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
                                      </>
                                    )}
                                  </svg>
                                  <span style={{ fontSize: '14px', fontWeight: 600, color: isSuccess ? '#2e7d32' : '#d32f2f' }}>
                                    {gcssResponse ? `HTTP ${gcssResponse.status_code} — ${gcssResponse.body?.status || result.status?.toUpperCase()}` : result.status?.toUpperCase()}
                                  </span>
                                </div>
                                {gcssDebugMsg && (
                                  <div style={{ fontSize: '13px', color: '#555', marginTop: '4px', lineHeight: '1.5' }}>
                                    {gcssDebugMsg}
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </details>
                  );
                })}
              </div>
            </div>
          )}
        </>
      )}

    </div>

    {/* Confirmation — not aggregate-closed; hide primary if every invoice BL is already closed */}
    {!afrCloseResult &&
      !closingAfr &&
      afrStatusCheck &&
      afrStatusCheck !== 'loading' &&
      afrStatusCheck.status !== 'found' &&
      !(closeAfrEligibleBls.length > 0 && closeAfrSelectableBls.length === 0) && (
      <>
        <McButton
          slot="primaryAction"
          appearance="primary"
          fit="medium"
          click={handleConfirmCloseAfr}
          disabled={
            closingAfr ||
            (closeAfrSelectableBls.length > 0 && selectedBlNumbersForClose.length === 0)
          }
        >
          Yes, Close AFR
        </McButton>
        <McButton slot="secondaryAction" appearance="neutral" variant="filled" fit="medium" dialogaction="cancel">
          Cancel
        </McButton>
      </>
    )}

    {/* Close only — all invoice BLs already closed (partial case still open elsewhere) */}
    {!afrCloseResult &&
      !closingAfr &&
      afrStatusCheck &&
      afrStatusCheck !== 'loading' &&
      afrStatusCheck.status !== 'found' &&
      closeAfrEligibleBls.length > 0 &&
      closeAfrSelectableBls.length === 0 && (
      <McButton slot="primaryAction" appearance="primary" fit="medium" dialogaction="ok">
        Close
      </McButton>
    )}

    {/* Close button — when task is already closed (info view) */}
    {!afrCloseResult && !closingAfr && afrStatusCheck && afrStatusCheck !== 'loading' && afrStatusCheck.status === 'found' && (
      <McButton slot="primaryAction" appearance="primary" fit="medium" dialogaction="ok">
        Close
      </McButton>
    )}

    {/* Close button — after close API call completes */}
    {afrCloseResult && !closingAfr && (
      <McButton slot="primaryAction" appearance="primary" fit="medium" dialogaction="ok">
        Close
      </McButton>
    )}
  </McModal>
      <div className="bl-list">
        {bldetails && bldetails.length > 0 ? (
          bldetails.map((blDetail, index) => {
            const uniqueInvoices = [...new Set(blDetail.relatedInvoices)];
            const joinedInvoices = uniqueInvoices.join(", ");
            return (
              <div className="bl-item" key={index}>
                <div className="bl-header-item">
                  <strong>BL No. {index + 1}:</strong>
                  <span
                    className="bl-number-text"
                    title={blDetail.blnumber || ''}
                  >
                    {blDetail.blnumber}
                  </span>
                </div>
                <div className="bl-invoices">
                  <strong>Attached Invoices:</strong>{" "}
                  {joinedInvoices || "Invoice not available"}
                </div>
              </div>
            );
          })
        ) : (
          <div className="no-documents-found">
            <p>{CASE_DETAILS_CONSTANTS.MESSAGES.NO_BL_NUMBERS_AVAILABLE}.</p>
          </div>
        )}
      </div>
    </div>
  );
};
 
export default InvoiceDetails;
